import { Accordion, AccordionTab } from "primereact/accordion";
import { Toolbar } from "primereact/toolbar";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";

import { format } from "date-fns";
import { IPermissionProps } from "../../../models/Login";
import { EmptySkillFilter, Filter, ISkillFilter } from "./Filter";
import { Fetch, baseUrl } from "../../../shared/Fetch";
import { Toast } from "primereact/toast";
import { SubTableEfficiencyReport } from "../SubTableEfficiencyReport";
import { SubTable } from "./SubTable";


interface IProps {
    permissions: IPermissionProps,
    toast: any,
}

export const SkillRecruiterWiseReport = (permissions: IPermissionProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: any, loading: boolean });
    const [skillFilter, setSkillFilter] = useState<ISkillFilter>(EmptySkillFilter);
    const dt = useRef<any>();
    const toast = useRef<any>();
    const [subTable, setSubTable] = useState({ open: false, salesID: 0, resType: 0, catID: 0 } as { open: boolean, salesID?: number, resType: number, catID?: number });
    // const [subTable1, setSubTable1] = useState({ open: false, salesID: 0, resType: 0, catID:0} as { open: boolean, salesID: number, resType: number, catID:number });
    const [subTable1, setSubTable1] = useState({ open: false, salesID: 0, resType: 0, catID: 0 } as { open: boolean, salesID?: number, resType: number, catID?: number });
    const [excelLoading, setExcelLoading] = useState<boolean>(false);
    const [tableLoad, setTableLoad] = useState(false);


    // const [salEffFilter, setSalEffFilter] = useState<ISkillFilter>(EmptySkillFilter);


    const hideSubTableDialog = () => {
        // setSubTable1({ open: false, salesID: 0, resType: 0, catID:0 });
        setSubTable({ open: false, salesID: 0, resType: 0, catID: 0 });
        setSubTable1({ open: false, salesID: 0, resType: 0, catID: 0 });

    };


    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const header = () => {
        return (
            <>Skill Recruiter Wise Report</>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Export" icon="pi pi-upload" className="p-button-help my-2" onClick={exportCSV} />
            </React.Fragment>
        );
    };

    console.log(subTable1);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Report_Skill_Recruiter/skillReportUserWiseRecruiter", "GET", null, `filter=${JSON.stringify(skillFilter)}`, toast);
        if (response) {
            const data: Array<any> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }



    const allReq = (rowData: any) => <span onClick={() => setSubTable({ open: true, salesID: rowData.recruiter_ID || 0, resType: 1, catID: rowData.req_Category || 0 })} className="cursor-pointer text-cyan-700 underline">{rowData.req}</span>
    const Serv = (rowData: any) => <span onClick={() => setSubTable({ open: true, salesID: rowData.recruiter_ID || 0, resType: 5, catID: rowData.req_Category || 0 })} className="cursor-pointer text-cyan-700 underline">{rowData.serv}</span>
    const UnServ = (rowData: any) => <span onClick={() => setSubTable({ open: true, salesID: rowData.recruiter_ID || 0, resType: 6, catID: rowData.req_Category || 0 })} className="cursor-pointer text-cyan-700 underline">{rowData.notAll}</span>
    const noOfSubRejSales = (rowData: any) => <span onClick={() => setSubTable1({ open: true, salesID: rowData.recruiter_ID, resType: 4, catID: rowData.req_Category || 0 })} className="cursor-pointer text-cyan-700 underline">{rowData.sRej}</span>
    const noOfECI = (rowData: any) => <span onClick={() => setSubTable1({ open: true, salesID: rowData.recruiter_ID, resType: 7, catID: rowData.req_Category })} className="cursor-pointer text-cyan-700 underline">{rowData.eci}</span>
    const Resume = (rowData: any) => <span onClick={() => setSubTable1({ open: true, salesID: rowData.recruiter_ID || 0, resType: 1, catID: rowData.req_Category || 0 })} className="cursor-pointer text-cyan-700 underline">{rowData.resume}</span>
    const noOfSubClient = (rowData: any) => <span onClick={() => setSubTable1({ open: true, salesID: rowData.recruiter_ID, resType: 3, catID: rowData.req_Category })} className="cursor-pointer text-cyan-700 underline">{rowData.ecs}</span>
    const noOfSubRejPV = (rowData: any) => <span onClick={() => setSubTable1({ open: true, salesID: rowData.recruiter_ID, resType: 5, catID: rowData.req_Category })} className="cursor-pointer text-cyan-700 underline">{rowData.pvr}</span>


    const downloadExcel = async (exceltype: number) => {
        setExcelLoading(p => p = true);
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"Report_Skill_Recruiter/skillwisegetexcel"}?` + `filter=` + encodeURIComponent(JSON.stringify(skillFilter)) + `&exceltype=${exceltype}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `SkillRecruiterWiseReport.xlsx`;
                a.href = href;
                a.click();
                a.href = '';
                setExcelLoading(p => p = false);
            } else if (response.status === 400) {
                const message = await response.text();
                toast.current.show({ severity: 'error', detail: message, life: 3000 });
                setExcelLoading(p => p = false);
            }
        } catch {
            setExcelLoading(p => p = false);
            toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    useEffect(() => {
        if (tableLoad) {
            loadTableData();
            setTableLoad(false);
        }
    }, [skillFilter]);

    return (
        <>

            {permissions.is_View && <React.Fragment>
                <Toolbar className="mb-1 py-0" left={() => <></>} right={rightToolbarTemplate}></Toolbar>
                <Accordion>
                    <AccordionTab header="Filter">
                        <Filter skillFilter={skillFilter} setSkillFilter={(skillFilter: ISkillFilter) => setSkillFilter(skillFilter)} downloadExcel={downloadExcel} excelLoading={excelLoading} onSearch={() => setTableLoad(true)} />
                    </AccordionTab>
                </Accordion>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    ref={dt} size="small" stripedRows showGridlines scrollable responsiveLayout="scroll" scrollHeight="70vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    value={tableData.tableData}
                    resizableColumns
                    emptyMessage="No Requirements found."
                    header={header}
                    loading={tableData.loading}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} footer={() => { return <span className="font-bold">Total</span> }} />
                    <Column field="company_name" sortable header="Comapny" />
                    <Column field="branchName" header="Branch" />
                    <Column field="user_Name" header="Recruiters" />
                    <Column field="teamManager" header="Team Manager" sortable />
                    <Column field="req_CategoryName" header="Skill Category" style={{ maxWidth: "8rem", overflow: "hidden" }} />
                    <Column field="req" header="Req#" sortable body={allReq}
                        footer={() => {
                            const Req = tableData.tableData.reduce((sum: any, item: { req: any; }) => sum + (item.req || 0), 0);
                            return <span
                                //onClick={() => setSubTable({ open: true, resType: 1 })} 
                                className="cursor-pointer text-cyan-700 underline">{Req}</span>;
                        }}
                    />
                    <Column field="resume" header="Resume#" sortable body={Resume}
                        footer={() => {
                            const Resume = tableData.tableData.reduce((sum: any, item: { resume: any; }) => sum + (item.resume || 0), 0);
                            return <span
                                //onClick={() => setSubTable1({ open: true, resType: 1 })} 
                                className="cursor-pointer text-cyan-700 underline">{Resume}</span>;
                        }} />
                    <Column field="serv" header="Serv#" sortable body={Serv}
                        footer={() => {
                            const Serve = tableData.tableData.reduce((sum: any, item: { serv: any; }) => sum + (item.serv || 0), 0);
                            return <span
                                //onClick={() => setSubTable({ open: true, resType: 5 })} 
                                className="cursor-pointer text-cyan-700 underline">{Serve}</span>;
                        }} />
                    <Column field="serv_Per" header="Serv(%)" sortable
                        footer={() => {
                            const Totalserved = tableData.tableData.reduce((sum: any, item: { serv: any; }) => sum + (item.serv || 0), 0);
                            const TotalReq = tableData.tableData.reduce((sum: any, item: { req: any; }) => sum + (item.req || 0), 0);
                            const percentage: number = (Totalserved / TotalReq) * 100;
                            return <span>
                                {percentage ? percentage.toFixed(1) : 0}
                            </span>
                        }}
                    />
                    <Column field="notAll" sortable header="UnServe#" body={UnServ}
                        footer={() => {
                            const NotAll = tableData.tableData.reduce((sum: any, item: { notAll: any; }) => sum + (item.notAll || 0), 0);
                            return <span
                                //onClick={() => setSubTable({ open: true, resType: 6 })} 
                                className="cursor-pointer text-cyan-700 underline">{NotAll}</span>;
                        }} />
                    <Column field="sRej" sortable header="SRej#t" body={noOfSubRejSales}
                        footer={() => {
                            const SRej = tableData.tableData.reduce((sum: any, item: { sRej: any; }) => sum + (item.sRej || 0), 0);
                            return <span
                                //onClick={() => setSubTable1({ open: true, resType: 4  })} 
                                className="cursor-pointer text-cyan-700 underline">{SRej}</span>;
                        }} />
                    <Column field="pvr" header="PVR#" body={noOfSubRejPV}
                        footer={() => {
                            const Pvr = tableData.tableData.reduce((sum: any, item: { pvr: any; }) => sum + (item.pvr || 0), 0);
                            return <span
                                //onClick={() => setSubTable1({ open: true, resType: 5 })} 
                                className="cursor-pointer text-cyan-700 underline">{Pvr}</span>;
                        }} />
                    <Column field="ecs" header="ECS#" body={noOfSubClient}
                        footer={() => {
                            const ECS = tableData.tableData.reduce((sum: any, item: { ecs: any; }) => sum + (item.ecs || 0), 0);
                            return <span
                                //onClick={() =>  setSubTable1({ open: true, resType: 3 })} 
                                className="cursor-pointer text-cyan-700 underline">{ECS}</span>;
                        }} />
                    <Column field="eci" header="ECI#" body={noOfECI}
                        footer={() => {
                            const ECI = tableData.tableData.reduce((sum: any, item: { eci: any; }) => sum + (item.eci || 0), 0);
                            return <span
                                //onClick={() =>  setSubTable1({ open: true, resType: 7 })} 
                                className="cursor-pointer text-cyan-700 underline">{ECI}</span>;
                        }} />
                    <Column field="po" header="PO#"
                        footer={() => {
                            const PO = tableData.tableData.reduce((sum: any, item: { po: any; }) => sum + (item.po || 0), 0);
                            return <span className="font-bold">{PO}</span>;
                        }} />
                </DataTable>
                <SubTableEfficiencyReport open={subTable.open} catID={subTable.catID} salesID={subTable.salesID} resType={subTable.resType} hideDialog={hideSubTableDialog} toast={toast} salEffFilter={skillFilter} />
                <SubTable open={subTable1.open} catID={subTable1.catID} salesID={subTable1.salesID} resType={subTable1.resType} hideDialog={hideSubTableDialog} toast={toast} salEffFilter={skillFilter} />
            </React.Fragment>}

            <Toast ref={toast} />
        </>
    );
}